import { REGEX_EMAIL, REGEX_PHONE, REGEX_PHONE_SYMBOLS, REGEX_WHITESPACES } from './constants'

export function removePhoneSymbols(phone = '') {
  return phone.replace(REGEX_PHONE_SYMBOLS, '').replace(REGEX_WHITESPACES, '')
}

export function cleanPhone(phone = '') {
  const [prefix, ...number] = phone.split(' ')

  if (!number?.length) {
    return removePhoneSymbols(phone)
  }

  return [prefix, removePhoneSymbols(number.join(''))].join('')
}

export function validateName({
  name = '',
  rules,
}: {
  name: string
  rules: { required: boolean; min?: number; max?: number }
}) {
  const errors = []
  const nameCleaned = name?.trim() || ''

  if (rules.required && nameCleaned.length === 0) {
    errors.push({ id: 'required' })
  }

  if (rules.min && nameCleaned.length < rules.min) {
    errors.push({ id: 'minLength', values: { min: rules.min } })
  }

  if (rules.max && nameCleaned.length > rules.max) {
    errors.push({ id: 'maxLength', values: { max: rules.max } })
  }

  return errors.length ? errors : null
}

export function validateEmail(value: string, rules?: { required: boolean }) {
  const errors = []
  const pattern = new RegExp(REGEX_EMAIL)

  if (rules?.required && typeof value === 'string' && value.length === 0) {
    errors.push({ id: 'required' })
  }

  if (!pattern.test(value)) {
    errors.push({ id: 'pleaseEmail' })
  }

  return errors.length ? errors : null
}

export function validatePassword(value: string, rules: { required: boolean; min: number }) {
  const errors = []

  if (rules.required && value.length === 0) {
    errors.push({ id: 'pleaseEnterPassword' })
  }

  if (rules.min && value.length < rules.min) {
    errors.push({ id: 'passwordLength', values: { min: rules.min } })
  }

  return errors.length ? errors : null
}

export function validatePhone(value: string, rules: { required: boolean }) {
  const cleanValue = REGEX_PHONE.exec(cleanPhone(value || ''))
  const errors = []

  if (rules?.required && !cleanValue) {
    errors.push({ id: 'required' })
  }

  return errors.length ? errors : null
}

export function validateConfirmPassword(
  current: string,
  confirm: string,
  rules: { required: boolean }
) {
  const errors = []

  if (rules.required && current === '') {
    errors.push({ id: 'subscriptionRepeatPassword' })
  }

  if (rules.required && current !== confirm) {
    errors.push({ id: 'passwordDifferent' })
  }

  return errors.length ? errors : null
}
